import { useState } from 'react';
import { Tabs } from '@shape-ds/components';
import { usePreventLeaveModal } from './usePreventEditLeave/usePreventEditLeave';

export const buildTabsConfig = <TabName extends string>(
  tabNames: TabName[],
  getLabel?: (key: TabName) => string,
) =>
  tabNames?.map((tabName, index) => ({
    label: getLabel?.(tabName) ?? tabName,
    value: index,
  })) ?? [];
type UseTabsProps<TabName extends string> = {
  tabNames: TabName[];
  getLabel?: (key: TabName) => string;
  onChange?: (activeTab: TabName) => void;
  defaultTab?: TabName;
};

export const useTabs = <TabName extends string>({
  tabNames,
  getLabel,
  onChange,
  defaultTab,
}: UseTabsProps<TabName>) => {
  const defaultIndex = defaultTab ? tabNames.indexOf(defaultTab) : 0;
  const [activeTab, setActiveTab] = useState(defaultIndex);
  const data = buildTabsConfig(tabNames, getLabel);
  const { openLeaveModal } = usePreventLeaveModal();

  if (tabNames[activeTab] === undefined && activeTab !== 0) {
    setActiveTab(0);
  }
  const onChangeTab = (value: number) => {
    setActiveTab(value);
    onChange && onChange(tabNames[value]);
  };

  return {
    activeTab: tabNames[activeTab],
    tabsComponent: (
      <Tabs
        data={data}
        onChange={(e, value) => {
          e.stopPropagation();
          const url = new URL(window.location.href);
          if (!url.searchParams.has('edit')) {
            return onChangeTab(value);
          }
          openLeaveModal(() => onChangeTab(value));
        }}
        value={activeTab}
        className="tabs"
      />
    ),
    setActiveTab,
  };
};
